<autocomplete-list-item (clicked)="triggerEvent()"> {{ item.firstName }} {{ item.lastName }} </autocomplete-list-item>
